import { unsafeCSS, type CSSResult } from 'lit';
import toArray from '@loadsmart/miranda-toolset/dist/to-array';

/**
 * Apply standard disabled style selector.
 * @param {string | string[]} selectors
 * @param {string} [subselector]
 */
function disableable(
	selectors: string | string[],
	subselector = '',
): CSSResult {
	return unsafeCSS(
		toArray(selectors)
			.map((selector) =>
				[`${selector}.is-disabled`, `${selector}:disabled`]
					.map((rule) => [rule, subselector].join(' '))
					.join(', '),
			)
			.join(', '),
	);
}

export default disableable;
